import { Injectable } from "@angular/core";
import {
  ActiveUserProfilePromiseService,
  CcyPairPromiseLookupService,
  ClientPromiseLookupService,
  CurrencyPairGroupPromiseLookupService,
  TradeTableDefinitionFactory,
  BmarkClientOrdersTableDefinitionFactory,
  TraderGroupLookupService,
  ProfilePromiseActionService,
  BmarkHedgeOrdersTableDefinitionFactory,
} from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxBaseBlotterFilteringService } from "../../../../bfx-base-blotter/bfx-base-blotter-filtering.service";
import { BmarkBlotterBaseFilteringService } from "app/bfx-bmark-summary/services/bmark-blotter-base-filtering.service";
import { BfxUserProfileService } from "app/bfx-common/services/bfx-user-profile.service";
import { BmarkBlotterViewFilterSelectionService } from "../../../services/bmark-blotter-view-filter-selection.service";

@Injectable()
export class BmarkClientOrdersFilterService extends BmarkBlotterBaseFilteringService {
  constructor(
    protected tableDefinitionFactory: BmarkClientOrdersTableDefinitionFactory,
    protected activeUserService: ActiveUserProfilePromiseService,
    protected clientService: ClientPromiseLookupService,
    protected currencyPairService: CcyPairPromiseLookupService,
    protected currencyPairGroupService: CurrencyPairGroupPromiseLookupService,
    protected traderGroupLookup: TraderGroupLookupService,
    protected profileActionService: ProfilePromiseActionService,
    protected userProfileService: BfxUserProfileService,
    protected viewFilterService: BmarkBlotterViewFilterSelectionService,
  ) {
    super(
      tableDefinitionFactory,
      activeUserService,
      clientService,
      currencyPairService,
      currencyPairGroupService,
      traderGroupLookup,
      profileActionService,
      userProfileService,
      viewFilterService,
    );
  }
}
